import React from 'react';
import { containers, feedback } from '@ecosystem/newron-design-system';

interface TrayContentWrapperProps {
  isLoading: boolean;
  children: React.ReactNode;
}

const { Tray } = containers;
const { DotsLoader } = feedback;

const TrayContentWrapper: React.FC<TrayContentWrapperProps> = ({ isLoading, children }) => {
  return (
    <Tray.Content>
      {isLoading && (
        <div className="absolute inset-0 flex justify-center items-center">
          <DotsLoader stretch testId="dots-loader" />
        </div>
      )}
      <div className={`${isLoading ? 'hidden' : ''} pb-4`}>{children}</div>
    </Tray.Content>
  );
};

export { TrayContentWrapper };
